var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconEditorPPElink = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "1.8", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { stroke: "none", fill: color, d: "M2.4,18.3H6c0.5,0,1,0.1,1.3,0.2C7.7,18.6,8,18.8,8.2,19c0.2,0.2,0.4,0.6,0.5,1c0.1,0.4,0.2,0.9,0.2,1.5\n\t\tc0,0.6-0.1,1.2-0.2,1.6c-0.1,0.4-0.3,0.7-0.5,1c-0.2,0.2-0.5,0.4-0.9,0.5c-0.4,0.1-0.8,0.2-1.3,0.2H4.3v3.4H2.4V18.3z M4.3,20v3.1\n\t\th1.4c0.3,0,0.5,0,0.6-0.1c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.5C7,22.2,7,21.9,7,21.5c0-0.3,0-0.6-0.1-0.8\n\t\tc0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.2-0.2-0.4-0.2C6.2,20.1,6,20,5.7,20H4.3z" }),
                React.createElement("path", { stroke: "none", fill: color, d: "M12.1,18.3h3.6c0.5,0,1,0.1,1.3,0.2c0.4,0.1,0.7,0.3,0.9,0.5c0.2,0.2,0.4,0.6,0.5,1c0.1,0.4,0.2,0.9,0.2,1.5\n\t\tc0,0.6-0.1,1.2-0.2,1.6c-0.1,0.4-0.3,0.7-0.5,1c-0.2,0.2-0.5,0.4-0.9,0.5c-0.4,0.1-0.8,0.2-1.3,0.2H14v3.4h-1.9V18.3z M14,20v3.1\n\t\th1.4c0.3,0,0.5,0,0.6-0.1c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2,0.1-0.5,0.1-0.8c0-0.3,0-0.6-0.1-0.8\n\t\tc0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2,0-0.4-0.1-0.6-0.1H14z" }),
                React.createElement("path", { stroke: "none", fill: color, d: "M21.8,18.3h5.8V20h-3.9v2.4h3.6V24h-3.6v2.6h3.9v1.5h-5.8V18.3z" })),
            React.createElement("g", { transform: "translate(-2.167 -1.718)" },
                React.createElement("path", { d: "M21.4,11v4.3c0,0.8-0.6,1.4-1.4,1.4h-7.8c-0.8,0-1.4-0.6-1.4-1.4V7.5c0-0.8,0.6-1.4,1.4-1.4h4.3\n\t\t" }),
                React.createElement("path", { d: "M19.3,3.9h4.3v4.3" }),
                React.createElement("path", { d: "M15.7,11.7l7.8-7.8" })))));
});
export default IconEditorPPElink;
//# sourceMappingURL=IconEditorPPElink.js.map